module.exports = __webpack_public_path__ + "static/media/portuguese-flag-large.f9d9e060.png";